import script from "./ClubSignupView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubSignupView.vue?vue&type=script&setup=true&lang=js"

import "./ClubSignupView.vue?vue&type=style&index=0&id=8431aeac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8431aeac"]])

export default __exports__